import { Link, Stack, Theme, Typography } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import { ProviderInfo } from '../../../types/type';
import { getPrettyPhoneNumber } from '../../../utils/Utilities';
import ServiceCompanyLogo from '../ServiceCompanyLogo/ServiceCompanyLogo';
import VisitWebSite from '../VisitWebsite/VisitWebsite';

interface ProviderInfoType {
  isRadioButtonEnabled: boolean;
  provider: ProviderInfo;
  checkedValue?: string;
  providerListItemClickHandler?: (providerID: string) => void | undefined;
}

const ServiceCompanyInfo = (prop: ProviderInfoType) => {
  const theme: Theme = useTheme();
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (prop.providerListItemClickHandler) {
      prop.providerListItemClickHandler(event.target.value);
    }
  };
  return (
    <Stack
      direction="row"
      spacing={1}
      justifyContent="space-between"
      alignItems={theme.custom.styles.showRadioButtonAtTop ? 'flex-start' : 'center'}
    >
      <Stack direction="row" spacing={1} justifyContent="flex-start" alignItems="center">
        {prop.isRadioButtonEnabled && (
          <Stack>
            <FormControlLabel
              id={prop.provider.providerID}
              value={prop.provider.providerID}
              control={
                <Radio
                  checked={prop.checkedValue === prop.provider.providerID}
                  onChange={handleChange}
                  sx={{
                    color: theme.custom.colors.radioButtonColor,
                    '&.Mui-checked': {
                      color: theme.custom.colors.radioButtonSelectedColor,
                    },
                    height: theme.custom.styles.showRadioButtonAtTop ? '20px' : '',
                    width: theme.custom.styles.showRadioButtonAtTop ? '20px' : '',
                    marginTop: theme.custom.styles.showRadioButtonAtTop ? '-3.6rem' : '',
                    marginLeft: '1rem',
                  }}
                />
              }
              label=""
            />
          </Stack>
        )}
        <Stack
          spacing={1}
          sx={{
            marginLeft:
              theme.custom.styles.showRadioButtonAtTop && prop.isRadioButtonEnabled ? '-0.5rem !important' : '2.8rem',
          }}
        >
          <Typography variant="body2" sx={theme.custom.styles.providerTitleStyle}>
            {prop.provider.providerName}
          </Typography>
          {prop.provider.providerPhone && (
            <Typography variant="body2">
              <Link
                underline="none"
                sx={theme.custom.styles.phoneNumberAndWebSiteStyle}
                href={`tel:${getPrettyPhoneNumber(prop.provider.providerPhone)}`}
              >
                {getPrettyPhoneNumber(prop.provider.providerPhone)}
              </Link>
            </Typography>
          )}
          {prop.provider.providerUrl && <VisitWebSite websiteAddress={prop.provider.providerUrl}></VisitWebSite>}
        </Stack>
      </Stack>
      {prop.provider.providerID && (
        <Stack justifyContent="flex-end">
          <ServiceCompanyLogo companyId={prop.provider.providerID}></ServiceCompanyLogo>
        </Stack>
      )}
    </Stack>
  );
};

export default ServiceCompanyInfo;
